"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FamilySection = void 0;
const react_1 = __importStar(require("react"));
const types_1 = require("../types");
const WebformFieldRouter_1 = require("../WebformFieldRouter");
const FamilySection = ({ section, data, errors, onChange, disabled, lookups, }) => {
    const familyData = data.family || [];
    const updateContact = (0, react_1.useCallback)((contactIdx, field, value) => {
        const updated = [...familyData];
        if (!updated[contactIdx]) {
            updated[contactIdx] = { guardianType: section.contacts[contactIdx]?.guardianType };
        }
        updated[contactIdx][field] = value;
        onChange('family', updated);
    }, [familyData, section.contacts, onChange]);
    return (react_1.default.createElement(react_1.default.Fragment, null, section.contacts.map((contact, idx) => {
        const resolvedFields = contact.fields.map(types_1.resolveFamilyField);
        return (react_1.default.createElement("div", { key: contact.id, className: "contact-card" },
            react_1.default.createElement("div", { className: "contact-card-header" },
                react_1.default.createElement("div", { className: "contact-avatar" }, contact.label.charAt(0)),
                react_1.default.createElement("div", { className: "contact-name" }, contact.label)),
            react_1.default.createElement("div", { className: "form-row" }, resolvedFields.map((field) => {
                if (field.visibleWhen) {
                    const depValue = familyData[idx]?.[field.visibleWhen.field];
                    if (depValue !== field.visibleWhen.value)
                        return null;
                }
                return (react_1.default.createElement("div", { key: field.key },
                    react_1.default.createElement(WebformFieldRouter_1.WebformFieldRouter, { field: {
                            ...field,
                            key: `family_${contact.id}_${field.key}`,
                        }, value: familyData[idx]?.[field.key] ?? '', onChange: (_key, val) => updateContact(idx, field.key, val), error: errors[`family.${idx}.${field.key}`], disabled: disabled, lookups: lookups })));
            }))));
    })));
};
exports.FamilySection = FamilySection;
